import { Row } from "antd";

type ErrorsListProps = {
  data: any;
};

export const ErrorsList = ({ data }: ErrorsListProps) => {
  return (
    <Row className="d-block">
      <p className="my-0">
        This portal user is already assigned to a customer in account:
      </p>
      <ul className="mt-2 mb-0 pl-3">
        {Object.keys(data).map((val: string, i: number) => (
          <li key={i}>{val}</li>
        ))}
      </ul>
    </Row>
  );
};
